import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Wraps a routed page so it fades in/out on navigation.
 *
 * Opacity-only on purpose: several popups render `position: fixed` overlays
 * *inside* pages, and a `transform` on an ancestor would re-anchor those fixed
 * elements to this wrapper and break full-screen overlays. A crossfade keeps
 * route changes smooth without touching layout.
 */
const PageTransition = ({ children }) => {
    const reduce = useReducedMotion();

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: reduce ? 0 : 0.26, ease: 'easeInOut' }}
            style={{ width: '100%' }}
        >
            {children}
        </motion.div>
    );
};

export default PageTransition;
